import { useState } from "react";
import { node } from "prop-types";
import { RootStore, AppStateStore } from "./App";
import { AppStoreContext, AppStateStoreContext } from "./AppStoreContexts";

export const AppStoreProvider = (props) => {
  const { children } = props;

  const [ root ] = useState(new RootStore());

  return (
    <AppStoreContext.Provider value={root}>
      {children}
    </AppStoreContext.Provider>
  );
};

export const AppStateStoreProvider = (props) => {
  const { children } = props;

  const [ root ] = useState(new AppStateStore());

  return (
    <AppStateStoreContext.Provider value={root}>
      {children}
    </AppStateStoreContext.Provider>
  );
};

AppStoreProvider.propTypes = {
  children: node.isRequired,
};

AppStateStoreProvider.propTypes = {
  children: node.isRequired,
};
